/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getTriggeredActionRows} from '../api'

 export const useQueryGetTriggeredActionRows = createReactQueryHook('getTriggeredActionRows', getTriggeredActionRows)
